<template>
  <n-modal
    :show="show"
    preset="card"
    title="Iniciar sesión"
    style="max-width: 380px"
    :bordered="false"
    :segmented="{ content: true, footer: true }"
    @update:show="onUpdateShow"
  >
    <n-form ref="formRef" :model="formValue" :rules="rules">
      <n-form-item path="identifier" label="Usuario o email">
        <n-input
          v-model:value="formValue.identifier"
          placeholder="Usuario / usuario@email.com"
        />
      </n-form-item>
      <n-form-item path="password" label="Contraseña">
        <n-input
          v-model:value="formValue.password"
          type="password"
          show-password-on="click"
          placeholder="••••••••"
          @keydown.enter.prevent="handleSubmit"
        />
      </n-form-item>
    </n-form>

    <n-alert
      v-if="errorMessage"
      type="error"
      :title="errorMessage"
      closable
      style="margin-bottom: 12px"
      @close="errorMessage = ''"
    />

    <template #footer>
      <div class="modal-footer">
        <button
          type="button"
          class="link-btn"
          @click="$emit('switch-to-register')"
        >
          ¿No tienes cuenta? Regístrate
        </button>
        <n-button type="primary" :loading="loading" @click="handleSubmit"
          >Entrar</n-button
        >
      </div>
    </template>
  </n-modal>
</template>

<script setup>
import { ref } from "vue";
import { useAuthStore } from "@/store/auth";

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(["update:show", "switch-to-register", "success"]);

const authStore = useAuthStore();
const formRef = ref(null);
const loading = ref(false);
const errorMessage = ref("");

const formValue = ref({ email: "", password: "" });

const rules = {
  email: [
    {
      required: true,
      message: "Introduce tu email",
      trigger: ["blur", "input"],
    },
  ],
  password: [
    {
      required: true,
      message: "Introduce tu contraseña",
      trigger: ["blur", "input"],
    },
  ],
};

function resetForm() {
  formValue.value = { email: "", password: "" };
  errorMessage.value = "";
}

function onUpdateShow(value) {
  emit("update:show", value);
  if (!value) resetForm();
}

async function handleSubmit() {
  errorMessage.value = "";
  try {
    await formRef.value?.validate();
  } catch {
    return; // errores de validación ya se muestran en cada campo
  }

  loading.value = true;
  try {
    await authStore.login({
      identifier: formValue.value.identifier,
      password: formValue.value.password,
    });
    emit("update:show", false);
    resetForm();
    emit("success");
  } catch (err) {
    errorMessage.value =
      err?.response?.data?.message ||
      err.message ||
      "No se pudo iniciar sesión.";
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.link-btn {
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  color: var(--ink-soft);
  text-decoration: underline;
  cursor: pointer;
}
.link-btn:hover {
  color: var(--melon-deep);
}
</style>
